import type { MaybeRefOrGetter } from "vue";
import type {ShortcutPlatform} from "@/utils/shortcuts";
import { useTheme } from "@/composables/theme";
import { useShortcut } from "@/composables/use-shortcut";
import { setLocale } from "@/services/i18n";
import {  SHORTCUTS } from "@/utils/shortcuts";

export interface UsePreferenceShortcutsOptions {
  enabled?: MaybeRefOrGetter<boolean>;
  platform?: ShortcutPlatform;
}

/**
 * Theme/language shortcuts for screens that render preference controls outside
 * the authenticated shell (login, signup, pricing, public invitations).
 * The shell owner replaces this one once the user is authenticated.
 */
export function usePreferenceShortcuts(options: UsePreferenceShortcutsOptions = {}) {
  const { mode, setMode } = useTheme();

  useShortcut(SHORTCUTS.toggleTheme, () => setMode(mode.value === "dark" ? "light" : "dark"), {
    enabled: options.enabled,
    platform: options.platform,
  });
  useShortcut(SHORTCUTS.localeEnglish, () => void setLocale("en"), {
    enabled: options.enabled,
    platform: options.platform,
  });
  useShortcut(SHORTCUTS.localePortuguese, () => void setLocale("pt"), {
    enabled: options.enabled,
    platform: options.platform,
  });
}
